import { getAxiosInstance } from '../../np-rest/rest';

// Fetch the latest AI grading report for a product (or by report id).
export const getAiGradingReport = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post('ai-grading/report', params);
            if (res && res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            return null;
        } catch (error) {
            return null;
        }
    };
};

// List AI grading reports for a product (history).
export const listAiGradingReports = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post('ai-grading/reports', params);
            if (res && res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            return { data: [], count: 0 };
        } catch (error) {
            return { data: [], count: 0 };
        }
    };
};
